<sm-dialog-template [header]="alertMessage" [subHeader]="alertSubMessage" iconClass="al-ico-alert">
  @if (moreInfo || resultMessage) {
    <div class="more-info">
      <div>{{resultMessage}}</div>
      @for (entityName of moreInfoEntities; track entityName) {
        <div>
          <br>
          <div>Relevant {{entityName}}:</div>
          @for (entity of moreInfo[entityName]; track entity) {
            <div class="entities">
              <a [href]="buildUrl(entity, entityName)" target="_blank"> {{entity.name}}</a>
            </div>
          }
        </div>
      }
    </div>
  }
</sm-dialog-template>
<mat-dialog-actions>
  <button mat-flat-button mat-dialog-close>{{okMessage}}</button>
</mat-dialog-actions>
